"use client";

import { FeedbackList } from "./feedback/FeedbackList";
import { FeedbackDetail } from "./feedback/FeedbackDetail";

export function TriageView({ canWrite }: { canWrite: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <FeedbackList mode="inbox" canWrite={canWrite} />
      <FeedbackDetail canWrite={canWrite} />
    </div>
  );
}
